import { MapPlannerPreview, Preview } from '@uml/uml-components';
import React, { useEffect, useState } from 'react';
import {
  getConsultation,
  getConsultationOpinion,
} from '../services/consultations';
import {
  getDistrictWithTimeout,
  getEditionForm,
  getProject,
  getProjectForm,
} from '../services/projects';
import { getFormData, getRequest } from '../services/procedures';

import Box from '@material-ui/core/Box';
import Card from '@material-ui/core/Card';
import Chip from '@material-ui/core/Chip';
import Comments from '../plugins/Comments';
import { Paper } from '@material-ui/core';
import ProjectPreviewOpinions from './ProjectPreviewOpinions';
import ReactDOM from 'react-dom';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import Wrapper from '../components//Wrapper';
import { getCookie } from '../utilities/cookie';
import { makeStyles } from '@material-ui/core/styles';
import { useSnackbar } from 'notistack';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
  },
  chip: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    width: 'max-content',
  },
  card: {
    marginBottom: theme.spacing(3),
  },
  inputDescription: {
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(1),
  },
  statusList: {
    display: 'flex',
    flexDirection: 'row',
  },
  title: {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: theme.spacing(4),
  },
  likeH4Size: {
    fontSize: '2.28rem',
    lineHeight: '110%',
  },
}));

const ProjectPreview = () => {
  const [previewData, setPreviewData] = useState({});
  const [highlightsData, setHighlightsData] = useState({});
  const [value, setValue] = useState(0);
  const [elements, setElements] = useState([]);
  const [projectId, setProjectId] = useState('');
  const { enqueueSnackbar } = useSnackbar();
  const classes = useStyles();
  const [comments, setComments] = useState([]);
  const [opinions, setOpinions] = useState({});
  const [planId, setPlanId] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const params = new URLSearchParams(window.location.search);
        setProjectId(params.get('projectId'));

        const { data: projectData } = await getProject(
          typeof objPk !== 'undefined' ? objPk : params.get('projectId'),
          isProfilePreview,
        );

        const { data: formData } =
          service === 'il'
            ? await getProjectForm(projectData.id)
            : await getEditionForm(projectData.edition);
        let totalEstimate =
          projectData.form_content?.estimate?.fields?.reduce(
            (sum, val) => sum + val.price,
            0,
          ) ?? 0;
        if (projectData?.form_content?.estimate?.withDocumentation) {
          const withDocs = parseInt(
            projectData.form_content.estimate.documentation_cost,
            10,
          );
          totalEstimate += isNaN(withDocs) ? 0 : withDocs;
        }
        setComments(projectData.external_comments);

        const tmpPreview = {
          totalEstimate,
          projectStatus: projectData.status,
          projectType: projectData.form_content?.project_range ?? '',
          authors: projectData?.form_content?.authors ?? [],
          projectPosition: projectData.form_content?.projectPosition ?? [],
        };

        try {
          const districtData = await getDistrictWithTimeout(
            projectData.form_content.district,
          );
          const district = await districtData.json();
          tmpPreview.district = district?.features?.map(
            (item) => item?.properties?.nazwa,
          );
        } catch {
          enqueueSnackbar(
            'Nie udało się pobrać danych o dzielnicach projektu.',
            {
              variant: 'error',
            },
          );
          tmpPreview.district = [];
        }

        setPreviewData({
          ...projectData.form_content,
          files_list: projectData.form_content.files,
          full_number: projectData?.full_number,
          files: projectData?.files ?? [],
          estimate: {
            ...projectData.form_content.estimate,
            fields: projectData.estimate_with_products_name,
          },
        });
        setOpinions({
          final_opinion: projectData?.final_opinion ?? {},
          formal_opinion: projectData?.formal_opinion ?? {},
        });
        setElements(formData.content);
        setHighlightsData(tmpPreview);
      } catch (error) {
        enqueueSnackbar('Nie udało się pobrać danych', {
          variant: 'error',
        });
        console.error(error);
      }
    };

    if (!['ks', 'pp'].includes(service)) {
      fetchData();
    }
  }, []);

  useEffect(() => {
    const fetchConsultationOpinion = async (id) => {
      try {
        const { data: projectData } = await getConsultationOpinion(id);
        const consId = projectData.consultation;
        const { data: formData } = await getConsultation(consId);

        setPreviewData({
          ...projectData.form_content,
          files_list: projectData.form_content.files,
          files: projectData?.files ?? [],
        });

        const tmpPreview = {
          title: projectData.consultation_name,
          fullNumber: projectData.full_number,
          category: projectData.category,
          projectType: projectData.form_content?.project_range ?? '',
          created: projectData.created,
          contactPerson: projectData?.form_content?.author,
          projectPosition: projectData.form_content?.projectPosition ?? [],
          thumbnailId: projectData.thumbnail_id,
          thumbnailUrl: projectData.custom_thumbnail_url,
        };
        setElements(formData.form_preview.content);
        setHighlightsData(tmpPreview);
      } catch (e) {
        enqueueSnackbar('Błąd pobierania danych', { variant: 'error' });
      }
    };

    const params = new URLSearchParams(window.location.search);

    if (params.get('opinionId') && service === 'ks') {
      fetchConsultationOpinion(params.get('opinionId'));
    }
  }, []);

  useEffect(() => {
    const fetchRequestData = async (id) => {
      try {
        const { data } = await getRequest(id, getCookie('mu_id'));
        const formData = await getFormData(id);
        setPreviewData({
          ...data.form_content,
          files: data.files,
          files_list: data.form_content.files,
        });
        const formContent = formData.data.content;
        setElements(formContent);
        const addressElement = formContent.find(
          (element) => element.subType === 'AreaDetails',
        );
        setPlanId(addressElement?.planId ?? false);
        setHighlightsData({
          author: data.form_content.author,
          status: data.status,
          created: data.created,
        });
      } catch (e) {
        enqueueSnackbar('Błąd pobierania danych', { variant: 'error' });
      }
    };
    const params = new URLSearchParams(window.location.search);

    if (params.get('requestId') && service === 'pp') {
      fetchRequestData(params.get('requestId'));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChange = (_event, newValue) => {
    setValue(newValue);
  };

  const TabPanel = (props) => {
    // eslint-disable-next-line react/prop-types,no-shadow
    const { children, value, index, space, ...other } = props;
    return (
      <div
        role='tabpanel'
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...other}
      >
        {value === index && <Box p={space ?? 2}>{children}</Box>}
      </div>
    );
  };

  const LABELS = {
    bo: 'Budżet obywatelski',
    pp: 'Planowanie przestrzenne',
    bz: 'Zielony Budżet',
    il: 'Inicjatywa lokalna',
    ks: 'Konsultacje społeczne',
  };

  return (
    <div className={classes.root}>
      <div className={classes.title}>
        <h1 className={classes.likeH4Size}>
          {previewData?.full_number ?? ''} {previewData?.title ?? ''}
        </h1>
        <Chip label={LABELS[service]} className={classes.chip} />
      </div>
      <Card className={classes.card}>
        <Paper square>
          <Tabs
            value={value}
            indicatorColor='primary'
            textColor='primary'
            onChange={handleChange}
          >
            <Tab label='Projekt' aria-label='Projekt' />
            <Tab label='Plan projektu' aria-label='Plan projektu' />
            {service !== 'ks' && service !== 'pp' && (
              <Tab label='Ocena' aria-label='Ocena' />
            )}
          </Tabs>
        </Paper>
        <TabPanel value={value} index={0} space={0}>
          <Preview
            currentService={service}
            elements={elements}
            previewData={previewData}
            highlightsData={highlightsData}
            isCMS
          />
          {showComments === 'True' && (
            <Comments
              userId={getCookie('mu_id')}
              userLastName={userLastName}
              projectId={projectId}
              comments={comments}
              userName={userName}
            />
          )}
        </TabPanel>
        <TabPanel value={value} index={1}>
          <MapPlannerPreview
            previewData={previewData?.addresses ?? ''}
            availableLayers={availableLayers}
            planId={planId}
            withItemsPreview={service === 'pp'}
          />
        </TabPanel>
        {service !== 'ks' && (
          <TabPanel value={value} index={2}>
            <ProjectPreviewOpinions opinions={opinions} />
          </TabPanel>
        )}
      </Card>
    </div>
  );
};

export default ProjectPreview;

ReactDOM.render(
  <Wrapper productionPrefix='prp' seed='project-preview'>
    <ProjectPreview />
  </Wrapper>,
  document.getElementById('cms-project-preview'),
);
